import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { ErrorBoundary } from './components/ErrorBoundary'
import { supabase } from './integrations/supabase/client'

async function init() {
  // ──────────────────────────────────────────────────────────────
  // Supabase auth callback handler dla HashRouter
  //
  // Problem: Supabase wysyła link w formacie:
  //   https://sokao-toys.pl/#access_token=xxx&type=recovery
  //
  // HashRouter traktuje fragment po # jako ścieżkę routingu,
  // co powoduje pustą stronę zamiast modalu.
  //
  // Rozwiązanie: zanim React wystartuje, dajemy Supabase czas
  // na odczytanie tokenów z hasha, potem czyścimy URL → #/
  // Następnie onAuthStateChange odpala PASSWORD_RECOVERY → modal.
  // ──────────────────────────────────────────────────────────────
  const hash = window.location.hash

  const isAuthCallback =
    hash.includes('access_token=') ||
    hash.includes('error_code=') ||
    hash.includes('type=recovery') ||
    hash.includes('type=signup')

  if (isAuthCallback) {
    await supabase.auth.getSession()

    // Jeśli link resetu hasła → przekieruj na profil z flagą
    const targetHash = hash.includes('type=recovery')
      ? '#/profile?from=recovery'
      : '#/'

    window.history.replaceState({}, document.title, window.location.pathname + targetHash)
  }

  createRoot(document.getElementById('root')!).render(
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  )
}

init()
